var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "wrapper-form",
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.handleSubmit($event)
        },
      },
    },
    [
      _c(
        "o-field",
        {
          attrs: {
            label: _vm.$t("trailer.capacityKg"),
            "label-for": "capacityKg",
            message: _vm.v$.capacityKg.$errors.length
              ? _vm.v$.capacityKg.$errors[0].$message
              : null,
          },
        },
        [
          _c("o-input", {
            attrs: {
              id: "capacityKg",
              placeholder: _vm.$t("trailer.capacityKgPlaceholder"),
            },
            model: {
              value: _vm.formData.capacityKg,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "capacityKg", $$v)
              },
              expression: "formData.capacityKg",
            },
          }),
        ],
        1
      ),
      _c(
        "o-field",
        {
          attrs: {
            label: _vm.$t("trailer.capacityM3"),
            "label-for": "capacityM3",
            message: _vm.v$.capacityM3.$errors.length
              ? _vm.v$.capacityM3.$errors[0].$message
              : null,
          },
        },
        [
          _c("o-input", {
            attrs: {
              id: "capacityM3",
              placeholder: _vm.$t("trailer.capacityM3Placeholder"),
            },
            model: {
              value: _vm.formData.capacityM3,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "capacityM3", $$v)
              },
              expression: "formData.capacityM3",
            },
          }),
        ],
        1
      ),
      _c(
        "o-field",
        {
          attrs: {
            label: _vm.$t("trailer.bodyType"),
            "label-for": "bodyType",
            message: _vm.v$.bodyType.$errors.length
              ? _vm.v$.bodyType.$errors[0].$message
              : null,
          },
        },
        [
          _c(
            "o-select",
            {
              attrs: {
                id: "bodyType",
                placeholder: _vm.$t("trailer.bodyTypePlaceholder"),
              },
              model: {
                value: _vm.formData.bodyType,
                callback: function ($$v) {
                  _vm.$set(_vm.formData, "bodyType", $$v)
                },
                expression: "formData.bodyType",
              },
            },
            _vm._l(_vm.optionsBodyType, function (bodyType) {
              return _c(
                "option",
                { key: bodyType.value, domProps: { value: bodyType.value } },
                [_vm._v(" " + _vm._s(bodyType.label) + " ")]
              )
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "o-field",
        {
          attrs: {
            label: _vm.$t("trailer.weight"),
            "label-for": "weight",
            message: _vm.v$.weight.$errors.length
              ? _vm.v$.weight.$errors[0].$message
              : null,
          },
        },
        [
          _c("o-input", {
            attrs: {
              id: "weight",
              placeholder: _vm.$t("trailer.weightPlaceholder"),
            },
            model: {
              value: _vm.formData.weight,
              callback: function ($$v) {
                _vm.$set(_vm.formData, "weight", $$v)
              },
              expression: "formData.weight",
            },
          }),
        ],
        1
      ),
      _c(
        "FormActions",
        [
          _c("FormActionsPrevious", {
            attrs: { "is-first-step": _vm.isFirstStep },
            on: { handlePrevious: _vm.handlePrevious },
          }),
          _c("FormActionsNext", { attrs: { "is-last-step": _vm.isLastStep } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }